import type { LocText } from '../api/types';

/**
 * Pick the best string out of a multilingual field: requested → en → uk (the project-wide source language) → any.
 * English goes before Ukrainian so a Moldovan or Polish family whose language is missing gets a widely read text,
 * not Ukrainian (QA: document hints showed in Ukrainian in the ro/ru cabinet).
 */
export function loc(v: LocText, locale: string): string {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  return v[locale] || v.en || v.uk || Object.values(v).find((x): x is string => !!x) || '';
}
